module.exports = __webpack_public_path__ + "img/15.4f2a5cd0.jpg";